                                                               
export const DEBUG_FLAG = 'SYNC_VIDEO_DEBUG' as const;

                                                   
export const LOG_BRAND_PREFIX = '[Sync Video]' as const;

                                          
export const APP_PREFIX = 'app/' as const;

                                                 
export const PACKAGE_PREFIX = 'package/' as const;
